/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Fragment from 'ember-data-model-fragments/fragment';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type SessionService from '@linc-technologies/linced-common/services/session';
import { peekPerson } from '@linc-technologies/linced-common/utils/load-people';
import type Person from 'linced-app/models/person';

// Proto: people.Learner.Sibling.
export default class Sibling extends Fragment {
  declare [Type]: 'people/sibling';

  @service
  declare session: SessionService;

  @attr('string', { defaultValue: '' })
  declare schoolId: string;

  @attr('string', { defaultValue: '' })
  declare personId: string;

  // person reads the sibling's person from the store. It does not load it.
  // The route or the component must load the siblings before render
  // (loadPeople with includeFormer). It is null for a sibling at a
  // different school.
  get person() {
    if (this.schoolId !== this.get('session.activeSchool')) {
      return null;
    }
    return peekPerson<Person>(
      this.store,
      this.personId,
      'Load the siblings in the route afterModel or in the task that opens the view (loadPeople with learner.localSiblingIds and includeFormer).',
    );
  }

  @alias('person.isLoaded')
  declare personLoaded: unknown;
}
